Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Group2331498174",
  {"root":"Group2331498174--root","tabs":"Group2331498174--tabs","breadcrumbs":"Group2331498174--breadcrumbs","tabsWrapper":"Group2331498174--tabsWrapper","header":"Group2331498174--header","mainButton":"Group2331498174--mainButton"},
  "",
  14,
  "Group2331498174"
);

